/* ========================= NPM ======================== */
// jQuery
import "./base/_jquery-global.js";

// Popper.js (* tooltip, popover, dropdown)
// import * as Popper from "@popperjs/core";

// Use following imports only where needed (not globally)
// Bootstrap modules (add as needed)
// import "bootstrap/js/dist/collapse";

// AOS
import AOS from "aos";

// Rellax
import Rellax from "rellax";

// Fancybox
import { Fancybox } from "@fancyapps/fancybox";

document.addEventListener("DOMContentLoaded", () => {
    AOS.init();

    let rellax = new Rellax(".rellax", {
        breakpoints: [576, 992, 1441],
    });

    $(".fancybox").fancybox();
});

// Animated Intro
import animatedIntroInit from "../lib/animated-intro-section/js/main.js";
animatedIntroInit();

// Stripe Navigation
import stripeModernizrInit from "../lib/stripe.com-navigation/js/modernizr-custom.js";
stripeModernizrInit();

import stripeNavInit from "../lib/stripe.com-navigation/js/main.js";
stripeNavInit();

/* ======================== BASE ======================== */
// Import utilities as needed
import {
    utl_setFooterYear,
    utl_handleModalClose,
    utl_ehElements,
    // utl_ehElements,
    // utl_toggleCookiesAlert,
    // utl_anchorScrollOffset,
} from "./base/_utils.js";

// Call utility functions after imported
utl_setFooterYear();
utl_handleModalClose();
// utl_toggleCookiesAlert();
// utl_anchorScrollOffset();
// document.querySelector('.eh-container') && utl_ehElements();

/* ===================== COMPONENTS ===================== */
import carouselsInit from "./components/_carousels";
document.querySelector(".carousel") && carouselsInit();

import interiorBgInit from "./components/_bg-top-interior.js";
interiorBgInit();

import headingStrikeThroughInit from "./components/_heading-strike-through.js";
headingStrikeThroughInit();

import newsCarouselInit from "./components/_news-carousel.js";
newsCarouselInit();

/* ======================== PAGES ======================= */
// Individual page scripts are added in the header of specific page's index file
